import type {PermissionsRecordType} from '../permissions';

export const userAbsencePermissions = {
  userAbsenceRead: {
    actionId: 'READ',
    resourceId: 'USER_ABSENCE',
    scopes: ['BRANCH'],
  },
  userAbsenceCreate: {
    actionId: 'CREATE',
    resourceId: 'USER_ABSENCE',
    scopes: ['BRANCH'],
  },
  userAbsenceUpdate: {
    actionId: 'UPDATE',
    resourceId: 'USER_ABSENCE',
    scopes: ['BRANCH'],
  },
  userAbsenceDelete: {
    actionId: 'DELETE',
    resourceId: 'USER_ABSENCE',
    scopes: ['BRANCH'],
  },
} satisfies PermissionsRecordType;
